import React, { useState } from 'react';
import { Modal, Button, List, Upload, Input, Popconfirm, message, Space } from 'antd';
import { UploadOutlined, DeleteOutlined, EyeOutlined, DownloadOutlined } from '@ant-design/icons';
import { useUploadPDF, useDeletePDF, useAddEquipmentDoc, useDeleteEquipmentDoc } from '../../../hooks/useEquipment';

const EquipmentDocsModal = ({ visible, onCancel, equipment }) => {
    const [docTitle, setDocTitle] = useState('');
    const [uploading, setUploading] = useState(false);

    const uploadPDFMutation = useUploadPDF();
    const deletePDFMutation = useDeletePDF();
    const addEquipmentDocMutation = useAddEquipmentDoc();
    const deleteEquipmentDocMutation = useDeleteEquipmentDoc();

    const handleUpload = async (file) => {
        if (!docTitle.trim()) {
            message.error('Please enter a document title');
            return false;
        }

        setUploading(true);
        try {
            // Upload PDF first
            const uploadResult = await uploadPDFMutation.mutateAsync(file);
            
            // Then add to equipment docs
            await addEquipmentDocMutation.mutateAsync({
                equipmentId: equipment.id,
                title: docTitle,
                docId: uploadResult.id
            });

            setDocTitle('');
            message.success('Document uploaded successfully');
        } catch (error) {
            console.error('Upload error:', error);
        } finally {
            setUploading(false);
        }

        return false; // Prevent default upload behavior
    };

  const handleDeleteDoc = async (doc) => {
    try {
        await deleteEquipmentDocMutation.mutateAsync(doc.id);
        
 
    } catch (error) {
        console.error('Delete error:', error.response.data[0]);
        message.error('Failed to delete document');
    }
};

    const handleViewDoc = (docId) => {
        const url = `https://api.dreasey.com/api/Storage/GetPDFById?Id=${docId}`;
        window.open(url, '_blank');
    };

    return (
        <Modal
            title={`Documents - ${equipment?.name || 'Equipment'}`}
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="close" onClick={onCancel}>
                    Close
                </Button>
            ]}
            width={700}
        >
            <div className="mb-4">
                <div className="flex gap-2 mb-3">
                    <Input
                        placeholder="Enter document title"
                        value={docTitle}
                        onChange={(e) => setDocTitle(e.target.value)}
                        style={{ flex: 1 }}
                    />
                    <Upload
                        beforeUpload={handleUpload}
                        showUploadList={false}
                        accept=".pdf"
                        disabled={!docTitle.trim() || uploading}
                    >
                        <Button
                            icon={<UploadOutlined />}
                            loading={uploading}
                            type="primary"
                            style={{ backgroundColor: '#298d9f', borderColor: '#298d9f' }}
                        >
                            Upload PDF
                        </Button>
                    </Upload>
                </div>
                <p className="text-xs text-gray-500">Only PDF files are allowed</p>
            </div>

            <List
                dataSource={equipment?.equipmentDocs || []}
                locale={{ emptyText: 'No documents uploaded' }}
                renderItem={(doc) => (
                    <List.Item
                        actions={[
                            <Button
                                key="Download"
                                type="text"
                                icon={<DownloadOutlined />}
                                onClick={() => handleViewDoc(doc.docId)}
                            >
                                Download
                            </Button>,
                            <Popconfirm
                                key="delete"
                                title="Are you sure to delete this document?"
                                onConfirm={() => handleDeleteDoc(doc)}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button
                                    danger
                                    type="text"
                                    icon={<DeleteOutlined />}
                                    loading={deleteEquipmentDocMutation.isLoading}
                                >
                                    Delete
                                </Button>
                            </Popconfirm>
                        ]}
                    >
                        <List.Item.Meta
                            title={doc.title}
                            description={`Document ID: ${doc.docId}`}
                        />
                    </List.Item>
                )}
            />
        </Modal>
    );
};

export default EquipmentDocsModal;